import { createAction } from 'redux-act';

export class LayoutActions {
  public static toggleNavbar = createAction();
}
